// Amazon Testimonials Read More Functionality
console.log('Amazon testimonials JS file loaded!');

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, setting up Read More functionality...');
  
  // Wait for existing slider to be initialized and then setup Read More
  setTimeout(function() {
    console.log('Setting up Read More after slider initialization...');
    checkTextClamp();
  }, 1000);
  
  // Additional checks to ensure proper detection after slider is fully rendered
  setTimeout(function() {
    console.log('Second check after slider should be fully rendered...');
    checkTextClamp();
  }, 2000);
  
  setTimeout(function() {
    console.log('Final check to ensure all elements are properly sized...');
    checkTextClamp();
  }, 3000);
  
  // Re-check text clamp when slider changes (if slider exists)
  if (typeof jQuery !== 'undefined') {
    // Wait a bit longer before setting up the slider event listener
    setTimeout(function() {
      if (jQuery('.testimonials-slider').hasClass('slick-initialized')) {
        jQuery('.testimonials-slider').on('afterChange', function(event, slick, currentSlide) {
          console.log('Slider changed, checking text clamp...');
          setTimeout(checkTextClamp, 100);
        });
      }
    }, 1500);
  }

  // Read More Modal Functionality
  const modal = document.getElementById('testimonial-modal');
  const closeBtn = document.getElementById('modal-close');
  
  // Function to check if text is clamped and show/hide Read More button
  function checkTextClamp() {
    console.log('Checking text clamp...');
    
    // Only check visible slides in Slick slider
    const visibleSlides = document.querySelectorAll('.testimonials-slider .slick-slide:not(.slick-cloned) .testimonial-content');
    console.log('Found visible testimonial contents:', visibleSlides.length);
    
    visibleSlides.forEach((content, index) => {
      const testimonialCard = content.closest('.testimonial-card');
      const readMoreBtn = testimonialCard.querySelector('.read-more-btn');
      
      console.log(`Testimonial ${index}:`, {
        hasButton: !!readMoreBtn,
        contentHeight: content.clientHeight,
        scrollHeight: content.scrollHeight,
        isVisible: testimonialCard.offsetParent !== null
      });
      
      if (readMoreBtn && testimonialCard.offsetParent !== null && content.clientHeight > 0) {
        // Simple method first - check if text content is long
        const textLength = content.textContent.trim().length;
        const screenWidth = window.innerWidth;
        const isSmallMobile = screenWidth <= 580;
        const isMobileOrTablet = screenWidth <= 980;
        console.log(`Text length: ${textLength}, Screen width: ${screenWidth}, Small Mobile: ${isSmallMobile}, Mobile/Tablet: ${isMobileOrTablet}`);
        
        // Character thresholds: ~230 chars for 5 lines on small mobile, ~370 chars for 8 lines on mobile, ~500 chars for 11 lines on desktop
        const charThreshold = isSmallMobile ? 230 : (isMobileOrTablet ? 370 : 500);
        if (textLength > charThreshold) {
          readMoreBtn.style.display = 'block';
          console.log(`Showing read more button for testimonial ${index} (text length: ${textLength} > threshold: ${charThreshold})`);
        } else {
          // Use height comparison for shorter texts
          const clone = content.cloneNode(true);
          clone.style.cssText = window.getComputedStyle(content).cssText;
          clone.style.webkitLineClamp = 'unset';
          clone.style.display = 'block';
          clone.style.position = 'absolute';
          clone.style.visibility = 'hidden';
          clone.style.height = 'auto';
          clone.style.maxHeight = 'none';
          clone.style.overflow = 'visible';
          clone.style.webkitBoxOrient = 'initial';
          
          // Insert clone and measure
          document.body.appendChild(clone);
          const fullHeight = clone.scrollHeight;
          const clampedHeight = content.clientHeight;
          
          console.log(`Testimonial ${index} heights:`, {
            fullHeight,
            clampedHeight,
            shouldShow: fullHeight > clampedHeight
          });
          
          // Remove clone
          clone.remove();
          
          // Show button based on screen size: 5+ lines on small mobile (≤580px), 8+ lines on mobile/tablet (≤980px), 11+ lines on desktop
          const lineHeight = parseInt(window.getComputedStyle(content).lineHeight) || 23;
          const screenWidth = window.innerWidth;
          const isSmallMobile = screenWidth <= 580;
          const isMobileOrTablet = screenWidth <= 980;
          const maxLinesBeforeReadMore = isSmallMobile ? 5 : (isMobileOrTablet ? 8 : 11);
          const maxHeightBeforeReadMore = lineHeight * maxLinesBeforeReadMore;
          
          console.log(`Line height: ${lineHeight}, Max height for ${maxLinesBeforeReadMore} lines: ${maxHeightBeforeReadMore}`);
          
          if (fullHeight > maxHeightBeforeReadMore) {
            readMoreBtn.style.display = 'block';
            console.log(`Showing read more button for testimonial ${index} (full height: ${fullHeight} > max: ${maxHeightBeforeReadMore})`);
          } else {
            readMoreBtn.style.display = 'none';
            console.log(`Hiding read more button for testimonial ${index} (full height: ${fullHeight} <= max: ${maxHeightBeforeReadMore})`);
          }
        }
      }
    });
  }
  
  // Check text clamp after slider is initialized
  setTimeout(checkTextClamp, 100);
  
  // Also check after a longer delay to ensure everything is loaded
  setTimeout(checkTextClamp, 1000);
  
  // Removed testing code that was forcing all buttons to show
  
  const readMoreBtns = document.querySelectorAll('.read-more-btn');

  // Function to create stars HTML
  function createStarsHTML(rating) {
    const numRating = parseFloat(rating);
    const fullStars = Math.floor(numRating);
    const hasHalfStar = numRating % 1 !== 0;
    let starsHTML = '';

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        starsHTML += '<span class="star filled">★</span>';
      } else if (i === fullStars + 1 && hasHalfStar) {
        const fillPercentage = (numRating % 1) * 100;
        starsHTML += `<span class="star half-filled" style="--fill-percentage: ${fillPercentage}%">★</span>`;
      } else {
        starsHTML += '<span class="star">★</span>';
      }
    }
    return starsHTML;
  }

  // Function to open modal
  function openModal(testimonialData) {
    document.getElementById('modal-name').innerHTML = testimonialData.name;
    document.getElementById('modal-date').innerHTML = testimonialData.date;
    document.getElementById('modal-stars').innerHTML = createStarsHTML(testimonialData.rating);
    document.getElementById('modal-review-title').innerHTML = testimonialData.title;
    document.getElementById('modal-testimonial').innerHTML = testimonialData.testimonial;
    
    // Update avatar
    const modalAvatar = document.getElementById('modal-avatar');
    if (testimonialData.avatar && testimonialData.avatar.trim() !== '') {
      // Create image element safely to avoid HTML injection
      const img = document.createElement('img');
      img.src = testimonialData.avatar;
      img.alt = 'Customer Avatar';
      
      modalAvatar.innerHTML = '';
      modalAvatar.appendChild(img);
    } else {
      // Show default avatar icon
      modalAvatar.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>`;
    }
    
    // Update verified badge visibility
    const verifiedBadge = document.querySelector('.modal-verified');
    if (verifiedBadge) {
      verifiedBadge.style.display = testimonialData.verified ? 'flex' : 'none';
    }
    
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  // Function to close modal
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = 'auto'; // Restore scrolling
  }

  // Add click event listeners to Read More buttons using event delegation
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('read-more-btn')) {
      const testimonialData = {
        name: e.target.getAttribute('data-name'),
        date: e.target.getAttribute('data-date'),
        rating: e.target.getAttribute('data-rating'),
        title: e.target.getAttribute('data-title'),
        testimonial: e.target.getAttribute('data-testimonial'),
        avatar: e.target.getAttribute('data-avatar'),
        verified: e.target.getAttribute('data-verified') === 'true'
      };
      openModal(testimonialData);
    }
  });

  // Close modal when clicking the X button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Close modal when clicking outside the modal content
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeModal();
    }
  });

  // Re-check text clamp on window resize to handle responsive behavior
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkTextClamp, 250);
  });
});
